import { render, staticRenderFns } from "./NomenclatureDropdownNodataTemplate.vue?vue&type=template&id=228c390b"
import script from "./NomenclatureDropdownNodataTemplate.vue?vue&type=script&lang=js"
export * from "./NomenclatureDropdownNodataTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports